export default function anonymous(props
/*``*/) {
var out='<div data-hook="player-container" tabindex="0" class="'+(props.styles.videoWrapper)+'"></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/root-container/templates/container.dot
// module id = 91
// module chunks = 0 1 2 3 4